import { MenuRepository } from 'vue-graphql-models';
import global from './repository/items/global';
import assets from './repository/items/assets';
import files from './repository/items/files';
import analytics from './repository/items/analytics';
import contacts from './repository/items/contacts';
import materials from './repository/items/materials';
import chemicals from './repository/items/chemicals';
import users from './repository/items/users';
import organizations from './repository/items/organizations';

const Menu = new MenuRepository([
  ...global,
  ...assets,
  ...files,
  ...analytics,
  ...contacts,
  ...materials,
  ...chemicals,
  ...users,
  ...organizations,
]);

export default Menu;
